module.exports = __webpack_public_path__ + "4ad52aa36bfb7e88f8185754656e269c.MP3";